export type LoyaltyGroup = {
	id: number;
	name: string;
	subscriptionsCount: number;
	numbersCount: number;
	createdBy: number;
};

const model: types.models.InputModel = {
	id: 'id',
	name: 'name',
	subscriptionsCount: 'subscriptionsCount',
	numbersCount: 'numbersCount',
	createdBy: 'createdBy',
};

export default model;
